<template>
  <div id="app">
    <StartUp />
  </div>
</template>

<script>
import StartUp from "@/pages/Startup.vue";
export default {
  components: { StartUp },
};
</script>

<style lang="scss" scoped>
#app {
  height: calc(100vh - 20px);
}
</style>
